/**
 * Consumer mailbox providers. Used only to show a soft "use your work email"
 * hint on the lead forms — never to block a submission.
 */
const FREE_MAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "ymail.com",
  "hotmail.com",
  "outlook.com",
  "live.com",
  "msn.com",
  "aol.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "proton.me",
  "protonmail.com",
  "gmx.com",
  "mail.com",
  "zoho.com",
  "yandex.com",
]);

/** True when `email` is on a consumer mailbox domain (case-insensitive). */
export function isFreeMailEmail(email: string): boolean {
  const at = email.lastIndexOf("@");
  if (at < 0) return false;
  return FREE_MAIL_DOMAINS.has(
    email
      .slice(at + 1)
      .trim()
      .toLowerCase(),
  );
}

export const FREE_MAIL_HINT =
  "A work email helps us tailor your mockup, but this one works too.";
